import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/feature/object-lock/feature-object-lock.service.ts
 * (internal to FeatureService; injected directly as an Angular 18 class).
 */
export { FeatureObjectLockService } from '@ng/core/feature/object-lock/feature-object-lock.service';

export const FeatureObjectLockServiceModule = angular.module('acme.common.service.objectLock', []).name;
